/*eslint-disable*/
export default {
  init() {
    $('.tabs__nav-tab li:first-child').addClass('news-active');
    $('.tabs__content-singlet').hide();
    $('.tabs__content-single:first').show();
    
    // Click function
    $('.tabs__nav-tab li').click(function(){
      $('.tabs__nav-tab li').removeClass('news-active');
      $(this).addClass('news-active');
      $('.tabs__content-single').hide();
      
      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });

    $(document).ready(function(){
      $(".news-card").slice(0, 3).show();
      $("#loadMore").on("click", function(e){
        e.preventDefault();
        $(".news-card:hidden").slice(0, 3).slideDown();
        if($(".news-card:hidden").length == 0) {
          $("#loadMore").text("No Content").addClass("noContent");
        }
      });
      
    })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
